import { app } from '@lib';

export default {
  queryStoredCardAccountList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/storedCardManage/report',
      params,
    });
  },
  // 课表点名记录统计-列表
  courseSignReport(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/courseSign/report',
      params,
    });
  },
  // 课表点名记录统计-总计
  courseSignTotal(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/courseSign/total',
      params,
    });
  },
  // 课表点名记录统计-详情
  courseSignDetail(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/courseSign/detail',
      params,
    });
  },
  studentAttendanceReport(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/studentAttendanceReport',
      params,
    });
  },
  studentAttendanceTotal(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/studentAttendanceTotal',
      params,
    });
  },
  courseSignRecord(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/courseSignRecord',
      params,
    });
  },
  // 查询课消记录
  findCourseSignCharge(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findCourseSignCharge',
      params,
    });
  },
  // 查询课消明细
  findCourseSignChargeDetail(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findCourseSignChargeDetail',
      params,
    });
  },
  // 查询收据明细
  findPaymentList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findPaymentList',
      params,
    });
  },
  // 查询退费明细
  findPaymentRefundList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findPaymentRefundList',
      params,
    });
  },
  // 项目支付明细
  findProductPaymentList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findProductPaymentList',
      params,
    });
  },
  // 查询全部订单明细
  findOrderItemAllPage(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findOrderItemAll/page',
      params,
    });
  },
  // 储值卡资金统计
  storedCardMoneyReport(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/storedCardMoney/report',
      params,
    });
  },
  // 储值卡资金流水明细
  queryStoredCardTransactionList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/queryStoredCardTransactions/report',
      params,
    });
  },
  // 课消统计
  findCourseMoney(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findCourseMoney',
      params,
    });
  },
  // 数据总览
  findNowDataReport(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findNowDataReport',
      params,
    });
  },
  // 当日简报
  findDataReport(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findDataReport',
      params,
    });
  },
  // 学费收入
  findTuition(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findTuition',
      params,
    });
  },
  // 学费收入
  findRefundMoney(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findRefundMoney',
      params,
    });
  },
  findStudentCourseFee(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findStudentCourseFee',
      params,
    });
  },
  findStudentCourseAmount(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findStudentCourseAmount',
      params,
    });
  },
  studentCourseCardReport(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/studentCourseCard/report',
      params,
    });
  },
  studentCourseCardTotal(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/studentCourseCard/total',
      params,
    });
  },
  // 老师销售业绩金额报表
  findAchievementBelonger(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findAchievementBelonger',
      params,
    });
  },
  // 老师销售业绩金额明细报表
  findAchievementBelongerDetail(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findAchievementBelongerDetail',
      params,
    });
  },
  // 老师课时列表
  findTeacherAchievement(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findTeacherAchievement',
      params,
    });
  },
  // 物品统计
  commodityGoodsReport(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/commodityGoodsReport',
      params,
    });
  },
  // 学费统计
  findTuitionCostReport(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findTuitionCostReport',
      params,
    });
  },
  // 回评统计
  findQandaCommentReport(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findQandaCommentReport',
      params,
    });
  },
  // 回评问卷
  qandaList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/qanda/list',
      params,
    });
  },
  // 教务-课程报表
  courseAttendanceReport(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/courseAttendanceReport',
      params,
    });
  },
  // 教务-班级报表
  classAttendanceReport(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/classAttendanceReport',
      params,
    });
  },
  // 教务-老师报表
  teacherAttendanceReport(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/teacherAttendanceReport',
      params,
    });
  },
  // 教务-在班人数
  classDataReport(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/classDataReport',
      params,
    });
  },
  // 教务-带班人数
  classDataTeacherReport(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/classDataTeacherReport',
      params,
    });
  },
  // 教务-在班学员明细
  inClassStudentDetail(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/inClassStudentDetail',
      params,
    });
  },
  // 教务-出勤明细
  rollCallDetail(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/rollCallDetail',
      params,
    });
  },
  // 教务-按课程合计
  courseAttendanceTotal(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/courseAttendanceTotal',
      params,
    });
  },
  // 教务-按班级合计
  classAttendanceTotal(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/classAttendanceTotal',
      params,
    });
  },
  // 教务-按老师合计
  teacherAttendanceTotal(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/teacherAttendanceTotal',
      params,
    });
  },
  // 教务-点名明细合计
  rollCallDetailTotal(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/rollCallDetailTotal',
      params,
    });
  },
  // 意向-试听转化分析-按课程
  allAuditionCourseReport(params) {
    return Promise.all([
      app.http.ajax({
        method: 'post',
        url: '/api/cs-pc-report/cs-report/reports/audition/courseReport',
        params,
      }),
      app.http.ajax({
        method: 'post',
        url: '/api/cs-pc-report/cs-report/reports/audition/courseTotal',
        params,
      }),
    ]);
  },
  // 意向-试听转化分析-老师
  allAuditionTeacherReport(params) {
    return Promise.all([
      app.http.ajax({
        method: 'post',
        url: '/api/cs-pc-report/cs-report/reports/audition/teacherReport',
        params,
      }),
      app.http.ajax({
        method: 'post',
        url: '/api/cs-pc-report/cs-report/reports/audition/teacherTotal',
        params,
      }),
    ]);
  },
  // 查询线索转换率-宁佐坤
  reportsClueConversion(params) {
    return Promise.all([
      app.http.ajax({
        method: 'post',
        url: '/api/cs-pc-report/cs-report/reports/clueConversion',
        params,
      }),
      app.http.ajax({
        method: 'post',
        url: '/api/cs-pc-report/cs-report/reports/clueConversionTotal',
        params,
      }),
    ]);
  },
  clueConversionTotal(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/clueConversionTotal',
      params,
    });
  },
  studentIntroduceReport(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/studentIntroduce/report',
      params,
    });
  },
  findPaymentAccountCustomRecord(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findPaymentAccountCustomRecord',
      params,
    });
  },
  findPaymentAccountCustomTotal(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findPaymentAccountCustomTotal',
      params,
    });
  },
  customPaymentAccount(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/paymentAccount/customPage',
      params,
    });
  },
  studentIntroduceReportDetail(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/studentIntroduce/detail/report',
      params,
    });
  },
  // 查询学员转化分析
  studentConversion(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/studentConversion',
      params,
    });
  },
  // 查询学员转化分析合计
  studentConversionTotal(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/studentConversionTotal',
      params,
    });
  },
  // 查询学员转化分析明细
  studentConversionDetail(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/studentConversionDetail',
      params,
    });
  },
  // 任务中心导出列表
  taskReportPage(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/taskExport/taskReportPage',
      params,
    });
  },
  // 导出
  doExport(p) {
    const params = p;
    const { exportType } = params;
    delete params.exportType;
    return app.http.ajax({
      method: 'post',
      url: `/api/cs-pc-report/cs-report/taskExport/doReport/${exportType}`,
      params,
    });
  },
  // 查询学员转化分析
  findDataReportAllInOne(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-report/cs-report/reports/findDataReportAllInOne',
      params,
    });
  },
};
